import { useState } from 'react';

export function useBoolean(initialValue: boolean) {
    const [bool, setIsBool] = useState(initialValue);
    function handleToggle() {
        setIsBool((val) => !val);
    }
    return { bool, handleToggle };
}
